import React, { useContext } from 'react';
import omit from 'lodash/omit';
import classnames from 'classnames';
import Button, { ButtonProps } from '../../../../Button';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './FooterButton.scss';

export type Props = {
  className?: string;
  height?: ButtonProps['height'];
  size?: 'small' | 'medium' | 'large';
  onClick?: (event: any) => void;
  view?: ButtonProps['view'];
  biData?: BiEvent;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  children?: React.ReactNode;
};

const FooterButton: React.FC<Props> = props => {
  const { view, height, size = 'medium', className } = props;
  const isMobile = useContext(MobileContext);

  const fullWidth = props.fullWidth ?? isMobile;
  return view === undefined ? (
    <BrandedButton
      // Take SolidButton doesn't have a height prop, so remove it
      {...omit(props, ['height'])}
      variant="brand-green"
      size={size}
      className={classnames(
        s['new-ds-footer-btn'],
        fullWidth && s['full-width'],
        s[size],
        props.className
      )}
    />
  ) : (
    <Button
      {...props}
      height={height || size}
      className={classnames(s['footer-btn'], fullWidth && s['full-width'], className)}
    />
  );
};
FooterButton.displayName = 'FooterButton';

export default FooterButton;
